import styled from "styled-components";

const Main = styled.div`
  grid-area: main;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  margin: auto;
  margin-bottom: 80px;
  align-items: center;
  width: 90%;
`;

export default Main;
